<template>
  <div>
    <v-card v-if="canConfirm" class="confirm-card">
      <v-row>
        <v-col xs="12" sm="6" md="9" lg="9" xl="10"
          >لطفا کد ملی طلبه را وارد فرمائید.</v-col
        >
        <v-col cols="12" sm="6" md="3" lg="3" xl="2">
          <v-text-field
            v-model="nationalCode"
            append-icon="mdi-magnify"
            single-line
            reverse
            hide-details
            placeholder="کد ملی طلبه"
            maxlength="10"
            :oninput="onInput"
            color="primary"
            style="display: contents"
          ></v-text-field>
        </v-col>
      </v-row>
      <template>
        <div v-if="showNoRequest">
          <span class="errorMessage"
            >برای این شخص درخواست تلبس ثبت نشده است</span
          >
        </div>
        <template v-if="detail != null">
          <div class="detailbox">
            <app-row title="نام:" :value="detail.FullName" />
            <app-row title="کد طلبگی:" :value="detail.NumSystem" />
            <app-row title="وضعیت:" :value="detail.StrState" />
          </div>
          <div v-if="detail.Status == 6">
            <span class="errorMessage">این طلبه پیشتر ملبس شده است.</span>
          </div>
          <div v-else-if="detail.Status != 4">
            <span class="errorMessage"
              >امکان تایید تلبس این طلبه توسط جنابعالی وجود ندارد.</span
            >
          </div>
          <div v-else style="margin-top: 30px">
            <!-- <v-row align="center">
              <v-col class="d-flex" cols="12" sm="3">
                <b>توضیحات</b>
              </v-col>
              <v-col class="d-flex" cols="12" sm="9">
                <v-textarea outlined v-model="comment" no-resize></v-textarea>
              </v-col>
            </v-row> -->
            <v-row class="ltr">
              <v-btn
                color="primary white--text"
                class="request"
                @click="applyRequest"
                rounded
              >
                صلاحیت اخلاقی ایشان را تایید می کنم
              </v-btn>
            </v-row>
          </div>
        </template>
      </template>
    </v-card>
  </div>
</template>

<script>
import { GetStudentState, hasConfirmPermission, Confirm } from "@/api/talabbos";
import DetailRow from "@/components/DetailRow";

export default {
  data() {
    return {
      nationalCode: "",
      detail: null,
      showNoRequest: false,
      canConfirm: false,
      comment: "",
    };
  },
  components: {
    appRow: DetailRow,
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
  },
  watch: {
    nationalCode(value) {
      if (value.length == 10) {
        this.GetStudentState();
      }
    },
  },
  created() {
    this.checkConfirm();
  },

  methods: {
    GetStudentState() {
      if (this.nationalCode.length == 10) {
        return new Promise((resolve, reject) => {
          GetStudentState(this.nationalCode)
            .then((response) => {
              this.detail = response.data;
              this.showNoRequest = this.detail == null;
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
    },
    checkConfirm() {
      return new Promise((resolve, reject) => {
        hasConfirmPermission()
          .then((response) => {
            if (response.data) {
              this.canConfirm = true;
            } else {
              this.$store.commit(
                "SET_SNACKBAR_TEXT",
                "تایید تلبس برای اساتید سطح 2 و بیشتر مجاز است."
              );
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    applyRequest() {
      console.log(this.detail);
      Confirm(this.detail.SrlStudent, this.detail.Fserial, this.comment)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

          this.nationalCode = "";
          this.detail = null;
        })

        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
};
</script>
<style>
.confirm-card {
  margin-top: 20px;
  padding: 20px;
}
.request {
  width: 300px !important;
  margin: 15px;
}
.detailbox {
  border: 3px solid green;
  border-radius: 10px;
  padding: 20px;
  margin: 30px auto 0;
}
.errorMessage {
  width: 100%;
  display: block;
  background-color: #d93b3b;
  color: white;
  padding: 10px 30px;
  line-height: 30px;
  height: 50px;
  border-radius: 15px;
  margin-top: 30px;
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: gray !important;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: gray !important;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: gray !important;
}
</style>
